import React, { useEffect, useState } from 'react';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { Box, Paper } from '@mui/material';
import { useQuery } from '@tanstack/react-query';

import { BankInfo } from '@tassomutuo-backoffice/types';
import BankInfosTableRenderCellAction from './BankInfosTableRenderCellAction';
import { getBankInfos } from '../../../../services/api/bank-info/bank-info';
import FilterGroupInput from './FilterGroupInput';
import { CtaButton } from '@tassomutuo-backoffice/ui';

interface IProps {
  onEditRowClick: (row: BankInfo) => void;
  onCreateNewClick: () => void;
  onDeleteRowClick: (bankInfoId: string) => Promise<BankInfo>;
}

const defaultPageModel = {
  page: 0,
  pageSize: 10,
};

const BankInfosTable = ({
  onEditRowClick,
  onCreateNewClick,
  onDeleteRowClick,
}: IProps) => {
  const [paginationModel, setPaginationModel] = useState(defaultPageModel);
  const [filterGroup, setFilterGroup] = useState('');

  const {
    isPending,
    data: bankInfosData,
    //error,
  } = useQuery({
    queryKey: ['BankInfos', paginationModel, filterGroup],
    queryFn: () =>
      getBankInfos({
        page: paginationModel.page + 1,
        pageSize: paginationModel.pageSize,
        group: filterGroup,
      }),
  });
  console.log('bank', bankInfosData);
  const [rowCountState, setRowCountState] = React.useState(
    bankInfosData?.totalResults || 0
  );

  useEffect(() => {
    setRowCountState((prevRowCountState) =>
      bankInfosData?.totalResults !== undefined
        ? bankInfosData?.totalResults
        : prevRowCountState
    );
  }, [bankInfosData?.totalResults, setRowCountState]);

  const onSubmitFilterGroup = (group: string) => {
    if (group) {
      setFilterGroup(group);
      setPaginationModel(defaultPageModel);
    } else {
      setFilterGroup('');
      setPaginationModel(defaultPageModel);
    }
  };

  const tableColumns: GridColDef<BankInfo>[] = [
    {
      field: 'id',
      headerName: 'ID',
      flex: 1,
    },
    {
      field: 'groupName',
      headerName: 'Nome del Gruppo',
      flex: 1,
      valueGetter: ({ row }) => `${row.company_info.group}`,
    },
    {
      field: 'officialWebsite',
      headerName: 'Sito Ufficiale',
      flex: 1,
      valueGetter: ({ row }) => `${row.company_info.official_website}`,
    },
    {
      field: 'revenue',
      headerName: 'Fatturato',
      flex: 1,
      valueGetter: ({ row }) => row.financial_info.revenue,
    },
    {
      field: 'netProfit',
      headerName: 'Utile Netto',
      flex: 1,
      valueGetter: ({ row }) => row.financial_info.net_profit,
    },
    {
      field: 'email',
      headerName: 'Email',
      flex: 1,
      valueGetter: ({ row }) => row.contact_info.email,
    },
    {
      headerName: ' ',
      field: ' ',
      flex: 0.5,
      sortable: false,
      renderCell: ({ row }) => (
        <BankInfosTableRenderCellAction
          onEditClick={() => onEditRowClick(row)}
          onDeleteClick={() => onDeleteRowClick(row.id)}
        />
      ),
      minWidth: 100,
    },
  ];

  return (
    <Box>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        gap={2}
      >
        <FilterGroupInput onSubmit={onSubmitFilterGroup} />
        <CtaButton variant="contained" onClick={onCreateNewClick}>
          Crea nuovo
        </CtaButton>
      </Box>

      <Paper>
        <DataGrid
          columns={tableColumns}
          rows={bankInfosData?.results || []}
          disableRowSelectionOnClick
          autoHeight
          rowCount={rowCountState}
          loading={isPending}
          pageSizeOptions={[10]}
          paginationModel={paginationModel}
          paginationMode="server"
          onPaginationModelChange={setPaginationModel}
        />
      </Paper>
    </Box>
  );
};

export default BankInfosTable;
